import type { ReactNode } from "react";
import { Button as AriaButton, Link as AriaLink, type ButtonProps as AriaButtonProps, type LinkProps as AriaLinkProps } from "react-aria-components";
import { cx } from "../cx.ts";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

interface Look {
  variant?: ButtonVariant;
  size?: "sm" | "md";
  /** Alleen een icoon: geef dan altijd een aria-label mee. */
  iconOnly?: boolean;
  block?: boolean;
}

function classes({ variant = "secondary", size = "md", iconOnly, block }: Look, extra?: string): string {
  return cx("ui-button", `ui-button--${variant}`, size === "sm" && "ui-button--sm", iconOnly && "ui-button--icon", block && "ui-button--block", extra);
}

export interface ButtonProps extends Omit<AriaButtonProps, "className" | "children">, Look {
  className?: string;
  children?: ReactNode;
  icon?: ReactNode;
}

export function Button({ variant, size, iconOnly, block, className, icon, children, isPending, ...rest }: ButtonProps) {
  return (
    <AriaButton {...rest} isPending={isPending} className={classes({ variant, size, iconOnly, block }, className)}>
      {isPending ? <span className="ui-spinner" aria-hidden="true" /> : icon}
      {iconOnly ? null : children}
    </AriaButton>
  );
}

export interface LinkButtonProps extends Omit<AriaLinkProps, "className" | "children">, Look {
  className?: string;
  children?: ReactNode;
  icon?: ReactNode;
}

/** Navigatie die eruitziet als knop (gebruikt de RouterProvider van de app). */
export function LinkButton({ variant, size, iconOnly, block, className, icon, children, ...rest }: LinkButtonProps) {
  return (
    <AriaLink {...rest} className={classes({ variant, size, iconOnly, block }, className)}>
      {icon}
      {iconOnly ? null : children}
    </AriaLink>
  );
}
